// extracted by mini-css-extract-plugin
export default {"input":"Input_input__MQ1i-","modeSelect":"Input_modeSelect__ufQ54"};